require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-the-gambia-boosting-resilience-and-unlocking-productive.json") })
        }
      }, "path---en-us-project-the-gambia-boosting-resilience-and-unlocking-productive");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-the-gambia-boosting-resilience-and-unlocking-productive!./.cache/json/en-us-project-the-gambia-boosting-resilience-and-unlocking-productive.json
// module id = 565
// module chunks = 231608221292675